<div *ngIf="!creating && publicPanelData[panelData.id]" class="list-panel alignRow alignColumn">
    <span class="text-panel-title alignColumn">
        {{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}
    </span>
    <div class="datapoint-item"
        [ngStyle]="{'grid-template-columns': '1fr '.repeat(((publicPanelData[panelData.id] ? publicPanelData[panelData.id].metricLabels : []).length) + 1)}">
        <span>{{publicPanelData[panelData.id] ? 'DataPoint' : ''}}</span>
        <span
            *ngFor="let label of publicPanelData[panelData.id] ? publicPanelData[panelData.id].metricLabels : []">{{label}}</span>
    </div>
    <ejs-listview #list class="listbox"
        [dataSource]='publicPanelData[panelData.id] ? publicPanelData[panelData.id].datapointMetrics ?? [] : []'
        cssClass='e-list-template'>
        <ng-template #template let-dataSource>
            <div class="ejs-listview-item alignRow datapoint-item"
                [ngStyle]="{'grid-template-columns': '1fr '.repeat(((publicPanelData[panelData.id] ? publicPanelData[panelData.id].metricLabels : []).length) + 1)}">
                <span>{{dataSource.datapoint.DPTitle}}</span>
                <span *ngFor="let metric of dataSource.metrics">{{metric}}</span>
            </div>
            <!-- {{dataSource.datapoint.SI}} -->
        </ng-template>
    </ejs-listview>
</div>

<div *ngIf="creating && panelData" class="list-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name) ?? 'Add Node'}}</span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <div class="datapoint-item"
        [ngStyle]="{'grid-template-columns': '1fr '.repeat((panelData.metricData.metricChoices.length) + 1)}">
        <span>DataPoint</span>
        <span
            *ngFor="let metric of panelData.metricData.metricChoices">{{panelData.metricData.metrics[metric].text}}</span>
    </div>
    <ejs-listview class="listbox" #list [dataSource]='panelData.datapoints' cssClass='e-list-template' width="100%">
        <ng-template #template let-dataSource>
            <div class="ejs-listview-item alignRow datapoint-item"
                [ngStyle]="{'grid-template-columns': '1fr '.repeat((panelData.metricData.metricChoices.length) + 1)}">
                <span>{{dataSource.DPTitle}}</span>
                <span *ngFor="let metric of panelData.metricData.metricChoices">{{metric}}</span>
            </div>
        </ng-template>
    </ejs-listview>
</div>

<div *ngIf="creating && !panelData" class="list-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>List Panel</span>
    </div>
    <div class="datapoint-item" style="grid-template-columns: 1fr 1fr 1fr 1fr;">
        <span>DataPoint</span>
        <span>Example Metric 1</span>
        <span>Example Metric 2</span>
        <span>Example Metric 3</span>
    </div>
    <ejs-listview class="listbox" #list
        [dataSource]='[{DPTitle: "Example Datapoint 1"}, {DPTitle: "Example Datapoint 2"}, {DPTitle: "Example Datapoint 3"}]'
        cssClass='e-list-template' width="100%">
        <ng-template #template let-dataSource>
            <div class="ejs-listview-item alignRow datapoint-item" style="grid-template-columns: 1fr 1fr 1fr 1fr;">
                <span>{{dataSource.DPTitle}}</span>
                <span>2.67</span>
                <span>4.55</span>
                <span>9.74</span>
            </div>
        </ng-template>
    </ejs-listview>
</div>

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>